import { Component } from '@angular/core';
import { Fase } from '../../../shared/models/fase';
import { TableHeader } from '../../../shared/models/table-header';
import { ToastService } from '../../../shared/services/toast.service';
import { FaseService } from '../../../shared/services/fase.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalService } from '../../../shared/services/modal.service';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';
import { ButtonVariant } from '../../../shared/enums/button-variant.enum';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../../../shared/components/table/table.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { DialogFaseComponent } from './dialog-fase/dialog-fase.component';

@Component({
  selector: 'app-fase',
  imports: [ButtonComponent, TableComponent, FormsModule],
  templateUrl: './fase.component.html',
  styleUrl: './fase.component.scss',
})
export class FaseComponent {
  faseList: Fase[] = [];
  headers: TableHeader[] = [
    { value: 'id', label: 'ID' },
    { value: 'nome', label: 'Descrição' },
    { value: 'sequencia', label: 'Sequência' },
  ];

  constructor(
    private toast: ToastService,
    private service: FaseService,
    private dialog: MatDialog,
    private modal: ModalService,
  ) {}

  ngOnInit() {
    this.loadFaseList();
  }

  loadFaseList() {
    this.service.getAll().subscribe({
      next: (value) => {
        if (value && value.content) {
          this.faseList = [...value.content];
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Não foi possível carregar as fases.',
        );
      },
    });
  }

  create() {
    const dialogRef = this.dialog.open(DialogFaseComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Fase salva!');
        this.faseList = [...this.faseList, result];
      }
    });
  }

  edit(item: Fase) {
    const data = {
      fase: item,
    };

    const dialogRef = this.dialog.open(DialogFaseComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Fase atualizada!');
        const index = this.faseList.findIndex((obj) => obj.id == result.id);
        if (index != -1) {
          this.faseList[index] = result;
          this.faseList = [...this.faseList];
        }
      }
    });
  }

  confirmDelete(item: Fase) {
    const dialog = this.modal.openConfirmationModal(
      'Exclusão de fase',
      'Deseja mesmo excluir?',
      'Excluir',
      ButtonVariant.d,
      'Cancelar',
      ButtonVariant.s,
    );
    dialog.subscribe((result) => {
      if (result) {
        this.delete(item.id);
      }
    });
  }

  delete(id: number) {
    this.service.delete(id).subscribe({
      next: () => {
        this.toast.showToast(ts.success, 'Local deleted.');
        this.faseList = this.faseList.filter((item) => item.id !== id);
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
      },
    });
  }
}
